import { render, staticRenderFns } from "./Remolques.vue?vue&type=template&id=30da4e77&scoped=true&"
import script from "./Remolques.vue?vue&type=script&lang=js&"
export * from "./Remolques.vue?vue&type=script&lang=js&"
import style0 from "./Remolques.vue?vue&type=style&index=0&id=30da4e77&lang=scss&scoped=true&"
import style1 from "./Remolques.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30da4e77",
  null
  
)

export default component.exports